module.exports = __webpack_public_path__ + "img/pijltje-rechts-groen.3bdf7433c3bfd9d5dcf66f931e319ae5.svg";